// extracted by mini-css-extract-plugin
export default {"root":"BannerButton-root","box":"BannerButton-box"};